import { type ReactNode } from 'react';

// Airbnb empty state — subtle border, warm text, generous vertical rhythm
export function EmptyState({
  title,
  description,
  action,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
}) {
  return (
    <div className="rounded-[22px] border border-surface-border bg-surface/80 px-6 py-10 text-center shadow-[var(--shadow-card)] backdrop-blur">
      <p className="text-feature font-semibold tracking-tight-feature text-ink">{title}</p>
      {description && <p className="mt-1.5 text-body text-ink-muted">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
